enum SecondaryAdCopyType {
    None = "None",
    SingleText = "SingleText",
    MultipleText = "MultipleText",
    MultipleTextWithLabel = "MultipleTextWithLabel"
}
export default SecondaryAdCopyType